import type { ReactNode } from 'react'

import { Icone, type NomeIcone } from './Icone.jsx'

interface PropsEstadoVazio {
  icone?: NomeIcone
  titulo: string
  descricao?: string
  acao?: ReactNode
}

export function EstadoVazio({ icone = 'busca', titulo, descricao, acao }: PropsEstadoVazio) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-4 flex size-14 items-center justify-center rounded-full bg-brand-50 text-2xl text-brand-600">
        <Icone nome={icone} />
      </div>
      {/* <h2>, não <h3>: nos dois lugares em que este componente aparece
          (catálogo da vitrine e lista do painel) ele fica logo abaixo do <h1>
          da página, e um <h3> ali pularia um nível da escada de títulos. */}
      <h2 className="mb-2 text-lg font-bold text-gray-900">{titulo}</h2>
      {descricao && <p className="max-w-md text-gray-500">{descricao}</p>}
      {acao && <div className="mt-6">{acao}</div>}
    </div>
  )
}
